import React, { Component } from "react"
import { connect } from "react-redux"
// import Lightbox from "react-images"
import Carousel, { Modal, ModalGateway } from "react-images"
import { setCurrentIndex, show, previous, next } from "../Actions/LightboxImages.action"

class LightboxImagesContainer extends Component {
    render() {
        return (
            <ModalGateway>
                {this.props.isOpen ? (
                    <Modal
                        onClose={this.props.onClose}
                        styles={{
                            blanket: (base) => ({ ...base, zIndex: 2100 }),
                            positioner: (base) => ({ ...base, zIndex: 2110 }),
                            dialog: (base) => ({ ...base, zIndex: 2120 }),
                        }}
                    >
                        <Carousel views={this.props.images} currentIndex={this.props.currentImage} />
                    </Modal>
                ) : null}
            </ModalGateway>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        images: state.lightboxImages.images,
        isOpen: state.lightboxImages.visible,
        currentImage: state.lightboxImages.index,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onClose: () => dispatch(show(false)),
        onClickNext: () => dispatch(next()),
        onClickPrev: () => dispatch(previous()),
        onClickThumbnail: (index) => dispatch(setCurrentIndex(index)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LightboxImagesContainer)
